import { render, staticRenderFns } from "./III.vue?vue&type=template&id=0f9dd8da&"
import script from "./III.vue?vue&type=script&lang=js&"
export * from "./III.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports